"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleError = handleError;
var _request = require("./request");
var _coreCallback = _interopRequireDefault(require("../core-callback"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Handles error responses
 *
 * @module core-network-error
 */

/**
* Returns the response object
*
* @param {*} error The error returned by the network library
* @return {object} The response object
*/
function getResponse(error) {
  return error.response || error.config || {};
}

/**
 * Returns the status code from a network error
 *
 * @param {*} error The error returned by the network library
 * @return {integer} The status code
 */
function getStatus(error) {
  return error.response ? error.response.status : error.code || '0';
}

/**
 * Returns the Gateway error object from the response, if available
 *
 * @param {*} response The response returned by the network library
 * @return {integer} The first gateway error object, otherwise empty object
 */
function getGatewayError(response) {
  return ((response.data || {}).errors || [])[0] || {};
}

/**
 * Tests an error to see if it is a timeout error
 *
 * @param {integer} status The status code of the error
 * @param {*} error The error object
 * @return {boolean} True if this is a timeout error, false otherwise
 */
function isTimeoutError(status, error) {
  return status === 408 || error.code === 'ECONNABORTED';
}

/**
 * Tests a gateway error to see if it is a rate limit error
 *
 * @param {integer} gatewayError The error response
 * @return {boolean} True if this is a rate limit error, false otherwise
 */
function isRateLimitError(gatewayError) {
  return gatewayError.error_code === '429-001' || gatewayError.error_code === '429-002';
}

/**
 * Handles an Axios network library error
 *
 * @param {string} url
 * @param {object} opts JS object containing all call options, including result callbacks
 * @param {object} error The error from the axios request
 * @param {Array} retries Array containing logic to retry the call.
 */
function handleError(url, opts, error) {
  var retries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, _request.getRetries)();
  if (!error) {
    return;
  }
  var response = getResponse(error);
  var status = getStatus(error);
  var message = error.message;
  if (isTimeoutError(status, error)) {
    if (typeof opts.requestTimeoutCallback === 'function') {
      opts.requestTimeoutCallback(response, status, message || 'Timeout Error');
    }
  } else {
    var gatewayError = getGatewayError(response);
    if (isRateLimitError(gatewayError)) {
      var data = {
        error_code: gatewayError.error_code,
        error_description: 'Rate limit error'
      };

      // send callback
      _coreCallback["default"].invokeParentCallback(_coreCallback["default"].callbacks.generalRatelimit, data);

      // 429 Rate limit error handling
      if (retries[429].length) {
        var retry = retries[429].pop();
        // set a timeout for the given timeout registered in the retry.
        // getting the calls registered for 429 error code.
        setTimeout(function () {
          (0, _request.sendWithAxios)(url, opts, retries);
        }, retry.timeout);
      } else {
        opts.failure(response, status, message || 'Rate Limit Retries Exceeded');
      }
    } else {
      opts.failure(response, status, message || 'Network Error');
    }
  }
}
//# sourceMappingURL=error.js.map